<template>
  <div class="fake-material-input">
    <div :id="cardElementId" class="card-element"></div>
    <div class="input-effect" :class="{ 'input-effect-focus': focus }"></div>
  </div>
</template>

<script>
const uuidv4 = require('uuid/v4')

export default {
  name: 'CardElement',
  props: {
    data: {
      type: Object,
      default: null
    },
    paymentIntentId: {
      type: String,
      default: null,
      required: false
    },
    showPostalCode: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    cardElement: null,
    stripe: null,
    elements: null,
    focus: false,
    cardElementId: 'card-element-' + uuidv4()
  }),

  watch: {
    paymentIntentId: function(paymentIntentId) {
      if (!paymentIntentId) {
        return
      }

      const _this = this

      this.stripe.retrievePaymentIntent(paymentIntentId).then(function(result) {
        if (result.error) {
          _this.$emit('error', result.error)
        } else {
          this.handleCardPayment()
        }
      })
    }
  },

  mounted() {
    // eslint-disable-next-line
    this.stripe = Stripe(process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY)

    this.elements = this.stripe.elements()
    this.cardElement = this.elements.create('card', {
      hidePostalCode: !this.showPostalCode
    })
    this.cardElement.mount('#' + this.cardElementId)

    this.cardElement.on('blur', () => {
      this.focus = false
      this.$emit('blur')
    })
    this.cardElement.on('focus', () => {
      this.focus = true
      this.$emit('focus')
    })
    this.cardElement.on('change', event => this.$emit('change', event))
  },

  beforeDestroy() {
    this.cardElement.unmount()
    this.cardElement.destroy()
  },

  methods: {
    handleCardPayment(clientSecret) {
      const _this = this
      _this.$emit('loading', true)
      this.stripe.handleCardPayment(clientSecret, this.cardElement, this.data).then(function(result) {
        _this.$emit('loading', false)
        if (result.error) {
          _this.$emit('error', result.error)
        } else {
          _this.$emit('success', result.paymentIntent)
        }
      })
    },

    confirmCardSetup(clientSecret) {
      const _this = this
      _this.$emit('loading', true)
      this.stripe
        .confirmCardSetup(clientSecret, {
          payment_method: {
            card: this.cardElement,
            billing_details: this.data
          }
        })
        .then(function(result) {
          _this.$emit('loading', false)
          if (result.error) {
            _this.$emit('error', result.error)
          } else {
            _this.$emit('success', result)
          }
        })
    }
  }
}
</script>

<style lang="stylus" scoped>
.fake-material-input {
  position: relative;
  width: 100%;
  padding: 8px 0;
  margin-bottom: 8px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.42);

  &.error {
    border-color: #E15141;
  }

  .input-effect {
    position: absolute;
    bottom: -1px;
    width: 0;
    height: 2px;
    left: 100%;
    margin-left: -50%;
    transition: width 300ms, left 300ms, margin-left 300ms;
    background-color: #4895EC;
  }

  .input-effect-focus {
    width: 100%;
    left: 0;
    margin-left: 0;
  }
}
</style>
